import { AppLink } from '@app/models/api';
import { AdminSectionName, AppLinkType } from '@app/enumerations';

interface MainNavigationConfigParameters {
	catcoverageDomain: string;
	catcoverageHomeLoggedOutUrl: string;
	catcoverageHomeLoggedInUrl: string;
	publicPagesBaseUrl: string;
	rootUrl: string;
	securedUrl: string;
	publicUrl: string;
	adminUrl: string;
	newBusinessApplicationPreliminaryUrl: string;
	signupUrl: string;
	claimsUrl: string;
	policyUrl: string,
	policyPacketUrl: string,
}

const MainNavigationConfig = (params: MainNavigationConfigParameters): AppLink[] => {

	let quoteLink: AppLink = new AppLink();
	quoteLink.id = 'quote';
	quoteLink.label = 'Quote';
	quoteLink.appLinkType = AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN;
	quoteLink.subLinks = [];

	quoteLink.subLinks = [
		{
			id: 'personalQuote',
			label: 'Personal',
			url: `${params.rootUrl}${params.securedUrl}${params.newBusinessApplicationPreliminaryUrl}/RES`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.IS_ROUTER | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: []
		},
		{
			id: 'commercialQuote',
			label: 'Commercial',
			url: `${params.rootUrl}${params.securedUrl}${params.newBusinessApplicationPreliminaryUrl}/COMM`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.IS_ROUTER | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: []
		},
	];

	const administrationLink: AppLink = {
		id: 'administration',
		label: 'Administration',
		url: undefined,
		appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
		subLinks: [
			{
				id: 'notices',
				label: 'Notices',
				url: `${params.catcoverageDomain}/Admin/notice_queue.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'accounting',
				label: 'Accounting',
				url: `${params.catcoverageDomain}/admin_accounting.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'producers',
				label: 'Producers',
				url: `${params.catcoverageDomain}/admin_producers.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'admin',
				label: 'Admin',
				url: `${params.catcoverageDomain}/admin_home.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'applications2',
				label: 'Applications',
				url: `${params.catcoverageDomain}/underwriterReview.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'reports',
				label: 'Reports',
				url: `${params.catcoverageDomain}/underwriter_reports.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'claims',
				label: 'Claims',
				url: `${params.catcoverageDomain}/admin_claims.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'underwriting',
				label: 'Underwriting',
				url: `${params.catcoverageDomain}/underwriterReview.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			},
			{
				id: 'policyMap',
				label: 'Policy Map',
				url: `${params.catcoverageDomain}/policyMap.aspx`,
				appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
				subLinks: []
			}
		]
	};	

	return [
		{
			id: 'homePublic',
			label: 'Home',
			url: params.catcoverageHomeLoggedOutUrl,
			appLinkType: AppLinkType.VISIBLE_ON_LOGOUT,
			subLinks: []
		},
		{
			id: 'home',
			label: 'Home',
			url: params.catcoverageHomeLoggedInUrl,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN,
			subLinks: []
		},
		{
			id: 'myPolicy',
			label: 'My Policy',
			url: `${params.rootUrl}${params.publicUrl}${params.policyUrl}${params.policyPacketUrl}`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGOUT | AppLinkType.IS_ROUTER,
			subLinks: []
		},
		quoteLink,
		{
			id: 'trackAndManage',
			label: 'Track & Manage',
			url: undefined,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: [
				{
					id: 'applications1',
					label: 'Applications',
					url: `${params.catcoverageDomain}/track_and_manage.aspx?tab=0`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				},
				{
					id: 'waitingOnPayment',
					label: 'Waiting On Payment',
					url: `${params.catcoverageDomain}/track_and_manage.aspx?tab=1`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				},
				{
					id: 'policies',
					label: 'Policies',
					url: `${params.catcoverageDomain}/track_and_manage.aspx?tab=2`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				},
				{
					id: 'onHold',
					label: 'On Hold',
					url: `${params.catcoverageDomain}/track_and_manage.aspx?tab=3`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.ADMIN_ONLY | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				}
			]
		},
		administrationLink,	
		{
			id: 'myAgency',
			label: 'My Agency',
			url: undefined,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: [
				{
					id: 'viewAgencyReports',
					label: 'View Agency Reports',
					url: `${params.catcoverageDomain}/producer_sales_reports.aspx`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				},
				{
					id: 'manageUserAccounts',
					label: 'Manage User Accounts',
					url: `${params.catcoverageDomain}/producer_users.aspx`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
					subLinks: []
				}
			]
		},
		{
			id: 'faq',
			label: 'FAQ',
			url: `${params.publicPagesBaseUrl}/faq`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.VISIBLE_ON_LOGOUT,
			subLinks: []
		},
		{
			id: 'claimCenterProducer',
			label: 'Claim Center',
			url: undefined,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: [
				{
					id: 'reportALossProducer',
					label: 'Submit A Claim',
					url: `${params.rootUrl}${params.securedUrl}${params.claimsUrl}`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN | AppLinkType.IS_ROUTER,
					subLinks: []
				},
			]
		},
		{
			id: 'claimCenterPublic',
			label: 'Claim Center',
			url: undefined,
			appLinkType: AppLinkType.VISIBLE_ON_LOGOUT | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: [
				{
					id: 'reportALossPublic',
					label: 'Submit A Claim',
					url: `${params.rootUrl}${params.publicUrl}${params.claimsUrl}`,
					appLinkType: AppLinkType.VISIBLE_ON_LOGOUT | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN | AppLinkType.IS_ROUTER,
					subLinks: []
				}
			]
		},
		{
			id: 'makePayment',
			label: 'Make Payment',
			url: `${params.catcoverageDomain}/all_policies_pay.aspx`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGIN | AppLinkType.VISIBLE_ON_LOGOUT | AppLinkType.RESTRICTED_FOR_NPBE_ADMIN,
			subLinks: []
		},
		{
			id: 'becomeAppointed',
			label: 'Become Appointed',
			url: `${params.rootUrl}${params.publicUrl}${params.signupUrl}`,
			appLinkType: AppLinkType.VISIBLE_ON_LOGOUT | AppLinkType.IS_ROUTER,
			subLinks: []
		},
	]
}

export default MainNavigationConfig;